/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../../apiResponse';
import { createApiResponseSchema } from '../../../apiResponse';

const adminTransactionSchema = z.object({
  id: z.string(),
  userId: z.string(),
  planKey: z.string(),
  platform: z.string(),
  transactionId: z.string(),
  originalTransactionId: z.string(),
  receiptData: z.string(),
  verificationStatus: z.string(),
  verificationResponse: z.string().nullable(),
  priceUsd: z.number().nullable(),
  priceMicros: z.number().nullable(),
  currency: z.string().nullable(),
  purchaseDate: z.number(),
  expiresDate: z.number().nullable(),
  isTrial: z.number(),
  isIntroOffer: z.number(),
  createdAt: z.number(),
});

export type IAdminTransaction = z.infer<typeof adminTransactionSchema>;

export const listTransactionsDataSchema = z.array(adminTransactionSchema);

export type IListTransactionsData = z.infer<typeof listTransactionsDataSchema>;

export const listTransactionsResponseSchema = createApiResponseSchema(
  listTransactionsDataSchema,
) as z.ZodSchema<IAPI<IListTransactionsData>>;

export type IListTransactionsResponse = IAPI<IListTransactionsData>;
